export default "__VITE_ASSET__4d668825__"